module.exports = __webpack_public_path__ + "img/af_mobile_app.6ce86252.png";